import { menuTitles } from '@/locales';
import { Icon } from '@bumble/ui-kit';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './locale-menu.module.scss';

export default function LocalMenu({ title }: { title?: string }) {
  const router = useRouter();
  const locale = router.locale || 'en';

  const { level1, level2 } = menuTitles[locale as keyof typeof menuTitles];

  return (
    <nav className={styles.local__menu}>
      <div className={styles.inner}>
        {router.pathname !== '/' && (
          <>
            <LocalMenuLink href="/">{level1}</LocalMenuLink>
            <LocalMenuLink href="/stories">{level2}</LocalMenuLink>
          </>
        )}

        {title && <LocalMenuLink href={`/stories/${router.query.slug}`}>{title}</LocalMenuLink>}
      </div>
    </nav>
  );
}

function LocalMenuLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <div>
      <Link href={href}>{children}</Link>
      <span className={styles.icon}>
        <Icon name="generic-chevron-right" />
      </span>
    </div>
  );
}
